/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution
     */
    infoLev?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution
     */
    linkUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution
     */
    linkNm?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCautionFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution {
    return JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCautionFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCautionFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': !exists(json, 'title') ? undefined : json['title'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'infoLev': !exists(json, 'infoLev') ? undefined : json['infoLev'],
        'linkUrl': !exists(json, 'linkUrl') ? undefined : json['linkUrl'],
        'linkNm': !exists(json, 'linkNm') ? undefined : json['linkNm'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCautionToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseConfirmGetResponseCaution | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'content': value.content,
        'infoLev': value.infoLev,
        'linkUrl': value.linkUrl,
        'linkNm': value.linkNm,
    };
}

